import { Button, Checkbox, Col, Flex, Row, Table } from "antd";
import React, { useState } from "react";
import { FilterIcon } from "../../../../../components/Icons";
import SearchAndFilter from "../../SearchAndFilter";
import moment from "moment";
import FileUpload from "../../../../../components/FileUpload";
import AuditReportDrawer from "../../../../../components/AuditReportDrawer";

function Compliance() {
  const [isAuditReportDrawerVisible, setIsAuditReportDrawerVisible] =
    useState(false);
  const handleOpenDrawer = () => {
    setIsAuditReportDrawerVisible(true);
  };
  const handleCloseDrawer = () => {
    setIsAuditReportDrawerVisible(false);
  };
  const auditScoreData = [
    {
      reportName: "Safety Compliance",
      status: "In Progess",
      progress: "75%",
      dueDate: moment("03/18/25"),
    },
    {
      reportName: "HR Training",
      status: "Completed",
      progress: "100%",
      dueDate: moment("03/15/25"),
    },
    {
      reportName: "Financial Audit",
      status: "Overdue",
      progress: "75%",
      dueDate: moment("03/12/25"),
    },
    {
      reportName: "IT Security Review",
      status: "Pending",
      progress: "50%",
      dueDate: moment("03/10/25"),
    },
    {
      reportName: "Data Privacy Check",
      status: "In Progess",
      progress: "75%",
      dueDate: moment("03/05/25"),
    },
  ];

  const auditScoreColumn = [
    {
      title: "REPORT NAME",
      dataIndex: "reportName",
      key: "reportName",
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "PROGRESS",
      dataIndex: "progress",
      key: "progress",
    },
    {
      title: "DUE DATE",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (t) => <span>{moment(t).format("MM/DD/YY")}</span>,
    },

    {
      title: "ACTIONS",
      dataIndex: "action",
      key: "action",
      render: (t) => (
        <div className="actions-btn-parent">
          <Button type="text" onClick={handleOpenDrawer}>
            View
          </Button>
        </div>
      ),
    },
  ];

  const docsAndProceduresColumn = [
    {
      dataIndex: "checked",
      key: "checked",
      render: () => <Checkbox className="checkbox" />,
    },
    {
      title: "DOCUMENT",
      dataIndex: "document",
      key: "document",
    },
    {
      title: "LAST MODIFIED",
      dataIndex: "lastModified",
      key: "lastModified",
      render: (m) => {
        const diff = moment().diff(m, "days", true);
        const threshold = 7;
        return (
          <span>
            {Math.abs(diff) <= threshold ? m.fromNow() : m.format("MM/DD/YY")}
          </span>
        );
      },
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      key: "action",
      render: (t) => (
        <Flex gap={20} className="actions-btn-parent">
          <Button type="text">View</Button>
          <Button type="text">Edit</Button>
          <Button type="text">Delete</Button>
        </Flex>
      ),
    },
  ];

  const docsAndProceduresData = [
    {
      document: "Privacy Policy",
      lastModified: moment("2025-04-30T10:00:00"),
    },
    {
      document: "Incident Management Policy",
      lastModified: moment("2025-04-29T12:00:00"),
    },
    {
      document: "Complaints & Feedback Policy",
      lastModified: moment("2025-04-27T12:00:00"),
    },
    {
      document: "Risk Management Policy",
      lastModified: moment("2025-04-23T12:00:00"),
    },
  ];

  const updateHistoryColumn = [
    {
      title: "DOCUMENT",
      dataIndex: "document",
      key: "document",
    },
    {
      title: "UPDATE TYPE",
      dataIndex: "updateType",
      key: "updateType",
    },
    {
      title: "ADMIN",
      dataIndex: "admin",
      key: "admin",
    },
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      render: (t) => moment(t).format("MM/DD/YYYY"),
    },
  ];

  const updateHistoryData = [
    {
      document: "Worker Screening Policy",
      updateType: "Document Updated",
      admin: "Admin John",
      date: moment("04/18/2024"),
    },
    {
      document: "Service Agreement",
      updateType: "Update Pushed to Users",
      admin: "Admin Sarah",
      date: moment("04/10/2024"),
    },
    {
      document: "Emergency Response Plan",
      updateType: "Document Updated",
      admin: "Admin Mark",
      date: moment("04/06/2024"),
    },
  ];

  return (
    <div className="compliance-container">
      <Row gutter={[40, 40]}>
        <Col span={24} lg={14}>
          <div className="left-content">
            <SearchAndFilter title="Audit Score Overview" />
            <Table
              pagination={false}
              dataSource={auditScoreData}
              columns={auditScoreColumn}
              rowClassName={(_, index) =>
                index % 2 === 1 ? "altRow" : "normalRow"
              }
              className="auditScoreTable"
              scroll={{ x: true }}
            />
            <SearchAndFilter title="Documents & Procedures" />
            <FileUpload />
            <Table
              pagination={false}
              dataSource={docsAndProceduresData}
              columns={docsAndProceduresColumn}
              className="docsAndProceduresTable"
              rowClassName={(_, index) =>
                index % 2 === 1 ? "altRow" : "normalRow"
              }
              scroll={{ x: true }}
            />
            <Button type="primary" className="pushUpdateBtn">
              Push Updates
            </Button>
            <SearchAndFilter title="Update History" />
            <Table
              pagination={false}
              dataSource={updateHistoryData}
              columns={updateHistoryColumn}
              rowClassName={(_, index) =>
                index % 2 === 1 ? "altRow" : "normalRow"
              }
              scroll={{ x: true }}
            />
          </div>
        </Col>
        <Col span={24} lg={10}>
          <div className="overview-content">
            <div className="content">
              <div className="filter-row">
                <h1>Report Completion Overview</h1>
                <div className="filterIcon">
                  <FilterIcon />
                </div>
              </div>
              <div className="chart-parent">
                <img
                  src={require("../../../../../assets/images/report-completion-overview.png")}
                />
              </div>
            </div>
            <div className="content">
              <div className="filter-row">
                <h1>Reports Due This Month</h1>
                <div className="filterIcon">
                  <FilterIcon />
                </div>
              </div>
              <div className="chart-parent">
                <img
                  src={require("../../../../../assets/images/reports-due-overview.png")}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <AuditReportDrawer
        open={isAuditReportDrawerVisible}
        onClose={handleCloseDrawer}
      />
    </div>
  );
}

export default Compliance;
